import { Instant, PlainDate } from "@/temporal"
import { enumSchema, objectSchema, type KeysMatching } from "vue-utils"
import { DocumentUpload } from "./DocumentUpload"
import { extend, GenericEntity, Id, Nullable } from "./GenericEntity"
import { TFSStatus } from "./TFSStatus"
import { UserTimeStamp } from "./UserTimeStamp"

export interface CommonTFSData extends GenericEntity {
	tfsNumber: string
	wkNumber: Nullable<string>
	validFrom: Nullable<PlainDate>
	validTo: Nullable<PlainDate>

	companyId: Id

	notes: string

	maximumShipments: Nullable<number>
	maximumActiveShipments: Nullable<number>
}
export const CommonTFSData = objectSchema<CommonTFSData>({
	...extend(GenericEntity),
	tfsNumber: String,
	wkNumber: Nullable(String),
	validFrom: Nullable(PlainDate.Schema),
	validTo: Nullable(PlainDate.Schema),

	companyId: Id,
	notes: String,

	maximumShipments: Nullable(Number),
	maximumActiveShipments: Nullable(Number),
})

export type TFSEntryDocumentKey = KeysMatching<TFSEntry, Nullable<DocumentUpload[]>>

export interface TFSEntry extends CommonTFSData {
	createdBy: UserTimeStamp
	consentIssued: Nullable<UserTimeStamp>
	closed: Nullable<UserTimeStamp>

	closedDocuments: Nullable<DocumentUpload[]>
	consentIssuedDocuments: Nullable<DocumentUpload[]>
	additionalDocuments: Nullable<DocumentUpload[]>
}
export const TFSEntry = objectSchema<TFSEntry>({
	...extend(CommonTFSData),
	createdBy: UserTimeStamp,
	consentIssued: Nullable(UserTimeStamp),
	closed: Nullable(UserTimeStamp),

	closedDocuments: Nullable(DocumentUpload.array()),
	consentIssuedDocuments: Nullable(DocumentUpload.array()),
	additionalDocuments: Nullable(DocumentUpload.array()),
})

export interface TFSEntryMetadata extends CommonTFSData {
	companyName: string

	status: TFSStatus

	created: Instant
	consentIssued: Nullable<Instant>
	closed: Nullable<Instant>

	activeShipments: number
	completedShipments: number
	cancelledShipments: number
	totalShipments: number
}
export const TFSEntryMetadata = objectSchema<TFSEntryMetadata>({
	...extend(CommonTFSData),
	companyName: String,
	status: enumSchema(TFSStatus),

	created: Instant.Schema,
	consentIssued: Nullable(Instant.Schema),
	closed: Nullable(Instant.Schema),

	activeShipments: Number,
	completedShipments: Number,
	cancelledShipments: Number,
	totalShipments: Number,
})
